import React, { Fragment } from 'react';
import { Card, CardBody, Col, Container, Row, Button, Input } from 'reactstrap';
import { RibbonService } from '../../../constant';
import { TableStriped } from '../../../components/tables/TableStriped';
import { useService } from '../../../hooks/service/useService';
import { ModalService } from '../../../components/services/ModalService';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';


export const IndexService = () => {

    const {
        service,
        nextPage, previousPage, goToPage, totalPageCount, currentPage, method,
        name, abbreviation, handleInputChange, validaciones, handleDelete,
        closeDialog, modal, modalTitle, loading, saveCreate, saveDelete, handleCreate, handleSearchService, handleUpdate, saveUpdate,

        // ? DIALOG DELETE
        closeDeleteAlert, modalAlert, showDeleteAlert,

        //? SEARCH AND DOWNLOAD EXCEL
        handleClearRibbon, searchRibbon, handleSearchRibbon,
        loadingExcel, handleExcelRibbon
    } = useService();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };


    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_work_order_type_service)}
                    title="Editar"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>


                <button
                    onClick={() => handleDelete(rowData.id_work_order_type_service)}
                    title="Eliminar"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#bf0d0d"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        );
    };

    return (
        <Fragment>
            {/* <Breadcrumb parent="Configuraciones" title={"Métodos de pago"} /> */}
            <Container fluid={true}>
                <div className='container-global-zoom'>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody className="p-1">
                                    <TitleDataTable
                                        titleTable={RibbonService}
                                        buttonActions={handleExcelRibbon}
                                        titleButton={RibbonService}
                                        isDisbled={loadingExcel}
                                        loadingIsDisabled={loadingExcel}
                                        titleCreate="Crear Trasporte"
                                        buttonActionsCreate={handleCreate}
                                        actionInput={handleSearchRibbon}
                                        valueFilter={searchRibbon}
                                        filterLocalStorage={true}
                                        cleanFilterLocalStorage={handleClearRibbon}
                                    />

                                    <div className="table-responsive">
                                        <DataTable
                                            value={service}
                                            paginator
                                            rows={10}
                                            responsiveLayout="scroll"
                                            rowsPerPageOptions={[10, 50, 100]}
                                            className="data-table p-datatable-striped p-datatable-sm"
                                            emptyMessage={
                                                <div className="text-center">
                                                    <img
                                                        src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                        style={{ width: "32%" }}
                                                        alt="Sin resultados"
                                                    />
                                                    <br />
                                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                        No se encontraron resultados.
                                                    </p>
                                                </div>
                                            }
                                        >
                                            <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                            <Column
                                                field="name"
                                                header="Nombre"
                                                sortable
                                                body={(rowData) => (
                                                    <span style={{ fontWeight: "bold" }}>
                                                        {rowData.name}
                                                    </span>
                                                )}
                                                headerStyle={headerStyle}
                                                style={cellStyle}
                                            />

                                            <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                        </DataTable>
                                    </div>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </div>

            </Container>
            <ModalService
                {
                ...{
                    modal, modalTitle, closeDialog, method, loading,
                    name, abbreviation, handleInputChange, validaciones,
                    saveCreate, saveUpdate, saveDelete
                }
                }
            />

            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar el servicio"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el servicio?"
                    alert1={true}
                    titleAlert1={name}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDelete}
                    maskClassName="custom-total-mask"
                    newDesingDialog={true}
                    iconNewDialog="fa fa-trash-o f-20"
                    headerColor="#8b0000"
                    newDesingDialogDelete={true}
                    closable={false}
                />
            )}
        </Fragment>
    )
}
